import React from 'react'
import { getLDClient } from './LaunchDarkly'
import lodash from 'lodash'

export function withLD<P extends { flags?: any; ldClient?: any }>(
  Component: React.ComponentType<P>,
) {
  return function WithLD(props: Omit<P, 'flags' | 'ldClient'>) {
    const flags = lodash
      .entries(getLDClient().allFlags())
      .map(([key, value]) => [lodash.camelCase(key), value])
      .reduce((acc, [key, value]) => {
        acc[key] = value
        return acc
      }, {})
    const ldClient = getLDClient()
    return <Component {...(props as P)} flags={flags} ldClient={ldClient} />
  }
}
